import type {
    default as FileProviderItemViewState,
    ImageLoadState,
} from '../store/schema/FileProviderItemViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'setThumbnailLoadState',
    function setThumbnailLoadState(
        viewState: FileProviderItemViewState,
        newLoadState: ImageLoadState
    ) {
        viewState.thumbnail.loadState = newLoadState;
    }
);
